import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { LOGIN } from 'constants/controllers'
import Main from './Main'

export default new Controller({
  name: LOGIN,
  route: 'login',
  controller (
    Router,
    { scrollMain, url, pageView = 'main', pageData = null, query: { r: redirectTo = '' } },
    render
  ) {
    const pageId = getUrl(LOGIN)

    render(
      { Main },
      {
        redirectTo
      },
      {
        pageId,
        pageView,
        className: 'login'
      }
    )

    return pageId
  }
})
